import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {version} from '../../../../environments/version';

@Component({
    selector: 'ngc-version-component',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VersionComponent implements OnInit {

    version: any = {};

    constructor() { }

    ngOnInit() {
        this.version = version;
    }
}
